import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Giveaway from './Tikex/Giveaway'

export default class Shortcode extends Component {
	render() {
		return (
			<Giveaway
				postId={this.props.wpObject.post_id}
				organizationShortId={this.props.wpObject.organization_short_id}
			/>
		)
	}
}

Shortcode.propTypes = {
	wpObject: PropTypes.object,
}
